export const depotOrderConstants = {
    DEPOT_ORDER_GET_BY_REF_DOC_NO_CRITERIA_REQUEST: 'DEPOT_ORDER_GET_BY_REF_DOC_NO_CRITERIA_REQUEST',
    DEPOT_ORDER_GET_BY_REF_DOC_NO_CRITERIA_SUCCESS: 'DEPOT_ORDER_GET_BY_REF_DOC_NO_CRITERIA_SUCCESS',
    DEPOT_ORDER_GET_BY_REF_DOC_NO_CRITERIA_FAILURE: 'DEPOT_ORDER_GET_BY_REF_DOC_NO_CRITERIA_FAILURE',
    CLEAN_DEPOT_ORDERS: 'CLEAN_DEPOT_ORDERS'
};

